import React from 'react';
import styles from '../MainteanceBanner.module.css';
import { InfoIcon, WarningIcon } from '@/components/base/Icons/RocheIconPack';
import { Notification } from '../types/Notification';
import { SuccesIcon } from '@/components/base/Icons/SuccesIcon';
import { ErrorIcon } from '@/components/base/Icons/ErrorIcon';

interface NotificationItemProps {
  notification: Notification;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification }) => {
  const iconMap = {
    warning: <WarningIcon />,
    info: <InfoIcon style={{ fill: 'lightBlue' }} />,
    error: <ErrorIcon />,
    success: <SuccesIcon />,
  };

  const renderIcon = () => {
    return iconMap[notification.notificationType] || notification.icon;
  };

  return (
    <div className={`${styles.notification} ${styles[notification.notificationType]}`}>
      <div className={styles.icon}>{renderIcon()}</div>
      <div className={styles.bannerContainer}>
        <div className={styles.text}>{notification.textToDisplay}</div>
        <div className={styles.dataContainer}></div>
      </div>
    </div>
  );
};

export default NotificationItem;
